import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SimpleFlexbox, TabItem } from 'ctm-components';
import styles from './tabs.css';

class Tabs extends Component {

    constructor(props) {
        super(props);
        const { options } = this.props;
        this.state = {
            activeTab: options ? options[0].id : '',
            borderClass: 'left'
        };
    }

    /**
     * Sets the active element
     * @param {String} tab - The tab id
     * @returns {Object} - Returns the className depending on if the tab is active
     */
    getActiveClassName = (tab) =>  {
        const { activeTab } = this.state;
        return tab === activeTab ? styles.active_text : styles.inactive_text;
    };

    /**
     * Sets the active element
     * @param {Event} e - the click event
     */
    clickHandler = (e) => {
        const borderClass = e.target.dataset.id;
        this.setState({ activeTab: e.target.id, borderClass });
    };

    /**
     * Gets the element prop
     * @param {Object} id - the id of the element
     * @param {Number} index - the order of the element
     * @returns {Object} - Returns the element props
     */
    getProps = (id, index) => (
        {
            'data-id': index === 0 ? 'left' : 'right',
            key: id,
            className: this.getActiveClassName(id),
            onClick: this.clickHandler,
            id
        }
    );

    /**
     * Gets the tab links
     * @param {Object} options - the options array
     * @returns {Array} - Returns an array of Anchor components with the label passed from the options array
     */
    buildChildren = (options = []) => options.map((option, index) => <TabItem {...this.getProps(option.id, index)}>{option.label}</TabItem>);

    /**
     * gets the active content
     * @param {Object} options - the options array
     * @returns {Node} - gets the content component
     */
    getContent = (options = []) => {
        const { activeTab } = this.state;
        const contentOption = options.find((option) => {
            return option.id === activeTab;
        });
        if (!contentOption) return null;
        return contentOption.content;
    };

    /**
     * Returns the Tabs component
     * @returns {Node} Tabs Component
     */
    render = () => {
        const { options } = this.props;
        const { borderClass } = this.state;
        return (
            <>
                <SimpleFlexbox display="flex" className={classNames(styles.header, styles[borderClass])}>
                    {this.buildChildren(options)}
                </SimpleFlexbox>
                <SimpleFlexbox display="flex" column>
                    {this.getContent(options)}
                </SimpleFlexbox>
            </>
        );
    };

}

Tabs.propTypes = {
    options: PropTypes.array
};

export { Tabs };
